module.exports = __webpack_public_path__ + "static/media/awesome-cafe.b9ddcb05.jpeg";